module.exports = __webpack_public_path__ + "img/border_Ellipse_3D.ea48fd05.svg";